import { useQuery } from '@apollo/client';
import { GetUpgradePaths } from '../components/ProductUpgradeMessage/__generated__/GetUpgradePaths';
import { GET_UPGRADE_PATHS_QUERY } from '../components/ProductUpgradeMessage/ProductUpgradeMessage.queries';

export interface UpgradePath {
  title: string;
  baseProduct: {
    title: string;
    sdbsId: number;
  };
}

type UpgradeVariants = Record<number, UpgradePath>;

const useUpgradePaths = () => {
  const { data, loading, error } = useQuery<GetUpgradePaths>(
    GET_UPGRADE_PATHS_QUERY,
    {}
  );

  const upgradePaths = data?.user?.upgradePaths;
  const customerEmail = data?.user?.customer?.email;

  const upgradeVariants = upgradePaths?.reduce(
    (acc: UpgradeVariants, item): UpgradeVariants => {
      if (!item) {
        return acc;
      }

      const { title: parentTitle, licensedproduct_id: parentSdbsId } = item;
      const newItems = item.upgrade_path.reduce(
        (subAcc: UpgradeVariants, subItem): UpgradeVariants => {
          if (!subItem) {
            return subAcc;
          }
          const { licensedproduct_id, title } = subItem;
          return {
            ...subAcc,
            [licensedproduct_id]: {
              title,
              baseProduct: {
                title: parentTitle,
                sdbsId: parentSdbsId,
              },
            },
          };
        },
        {}
      );
      return { ...acc, ...newItems };
    },
    {}
  );

  return { loading, error, customerEmail, upgradePaths, upgradeVariants };
};

export default useUpgradePaths;
